class EventBusSingleton {
    private emitter: Phaser.Events.EventEmitter | null = null;
    get(): Phaser.Events.EventEmitter {
        if (this.emitter == null) {
            this.emitter = new Phaser.Events.EventEmitter();
        }
        return this.emitter;
    }
}

export const EventBus = new EventBusSingleton();